import { jsx as _jsx } from "react/jsx-runtime";
import React, { useContext } from "react";
export { EditorDependencyInjectionContextProvider, useEditorDependencyInjectionContext };
const Context = /*#__PURE__*/ React.createContext(undefined);
function EditorDependencyInjectionContextProvider({ dependencyInjectionContext, children }) {
    return /*#__PURE__*/ _jsx(Context.Provider, {
        value: dependencyInjectionContext,
        children: children
    });
}
function useEditorDependencyInjectionContext() {
    const dependencyInjectionContext = useContext(Context);
    return dependencyInjectionContext;
}
